import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';

import { BREAKPOINTS, COLORS } from '../../../ui/variables';
import SmallDoorVetLogo from '../../../images/small-door-vet-logo.svg';
import Navigation from './Navigation';
import MobileNavigation from '../lp/MobileNavigation';
import { NAV_HEIGHTS } from '../types';
import { saveParamsToCookie } from '../../../utils/captureUrlParams';

const Container = styled.header<{ sticky: boolean }>`
  position: ${props => (props.sticky ? 'sticky' : 'inherit')};
  top: 0;
  width: 100%;
  height: ${NAV_HEIGHTS.DESKTOP};
  padding: 0 70px;
  background: ${COLORS.WHITE};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  box-shadow: inset 0px -2px 0px ${COLORS.LIGHT_GRAY};
  transition: box-shadow 200ms ease;

  @media ${BREAKPOINTS.TABLET} {
    height: ${NAV_HEIGHTS.TABLET};
    padding: 0 40px;
  }

  @media ${BREAKPOINTS.MOBILE} {
    padding: 0 20px;
  }
`;

const Logo = styled(Link)`
  display: block;
  background: url(${SmallDoorVetLogo});
  background-repeat: no-repeat;
  width: 160px;
  height: 46px;
  flex-shrink: 0;
  margin-right: 48px;

  @media ${BREAKPOINTS.TABLET} {
    background-size: 120px;
    width: 120px;
    height: 32px;
  }

  @media ${BREAKPOINTS.MOBILE} {
    background-size: 110px;
    width: 110px;
    height: 29px;
  }
`;

const DesktopNavigation = styled(Navigation)`
  display: none;

  @media screen and (min-width: 1180px) {
    display: flex;
  }
`;

const Mobile = styled.div`
  display: none;

  @media screen and (max-width: 1179px) {
    display: block;
  }
`;

interface Props {
  sticky?: boolean;
  v2colors?: boolean;
  cta: {
    text: string;
    to?: string;
    href?: string;
  };
}

const Header = ({ sticky = true, v2colors = false, cta }: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    saveParamsToCookie();
  }, []);

  return (
    <Container sticky={sticky || menuOpen}>
      <Logo to='/' />
      <DesktopNavigation v2colors={v2colors} cta={cta} />
      <Mobile>
        <MobileNavigation
          v2colors={v2colors}
          menuOpen={menuOpen}
          toggleMenu={toggleMenu}
          cta={cta}
        />
      </Mobile>
    </Container>
  );
};

export default Header;
